import { ScopeButton } from '@monorepo/shared-lib';
import { Typography } from 'antd';
import { StyledCard } from 'components/Custom/card';
import { ProviderLogoNav } from 'components/Custom/ProviderLogoNav';
import { CardDescSpan } from 'components/Custom/spans';
import type { CSSProperties } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const { Text: AntTypographyText } = Typography;

export const GROUP_OVERVIEW_ENTITY_COL_WIDTH_PX = 150;

export const GROUP_OVERVIEW_ENTITY_COL_CELL_STYLE: CSSProperties = {
  width: `${GROUP_OVERVIEW_ENTITY_COL_WIDTH_PX}px`,
  maxWidth: `${GROUP_OVERVIEW_ENTITY_COL_WIDTH_PX}px`,
};

export const groupOverviewEntityColumnOnCell = () => ({
  style: GROUP_OVERVIEW_ENTITY_COL_CELL_STYLE,
});

export const GroupOverviewEntityNameLink = styled(Link)`
  text-decoration: none;
  min-width: 0;
  &:hover {
    text-decoration: underline;
  }
`;

export const GroupOverviewEntitySpace = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  min-width: 140px;
`;

export const GroupOverviewProviderLogoNav = styled(ProviderLogoNav)`
  height: 32px;
  display: block;
  flex-shrink: 0;
  line-height: 0;
`;

export const GroupOverviewEntityIcon = styled.img`
  display: block;
  width: 25px;
  padding-top: 4px;
`;

export const GroupOverviewEntityIconPlaceholder = styled.span`
  display: inline-flex;
  width: 25px;
  height: 32px;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  font-weight: 600;
  background-color: #e8e8e8;
  color: #666;
  border-radius: 2px;
  flex-shrink: 0;
`;

export const GroupOverviewEntityNameText = styled(AntTypographyText)`
  && {
    font-size: 13px;
    max-width: 100px;
  }
`;

export const GroupSummarySection = styled.div`
  padding-top: 20px;
  display: flex;
  justify-content: center;
`;

export const GroupSummaryCard = styled(StyledCard)`
  border: 1px solid var(--color-border, #dbeae3);
  box-shadow: 0 4px 10px 0 #0000000d;
  margin: 0;
  max-width: 1250px;
  width: 100%;
  overflow: auto;
`;

export const GroupSummaryCardBody = styled.div`
  padding: 20px;
`;

export const GroupSummaryHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  flex-wrap: wrap;
`;

export const GroupSummaryHeaderLeft = styled.div`
  flex: 1 1 240px;
  min-width: 0;
`;

export const GroupSummaryNote = styled(CardDescSpan)`
  display: block;
  margin-top: 8px;
  line-height: 1.5;
  max-width: 800px;
`;

export const GroupSummaryTableWrap = styled.div`
  overflow-x: auto;
  margin-top: 16px;
`;

/** ScopeButton only applies fontSize from props; use this for 13px / 700 in group overview */
export const GroupOverviewTableActionButton = styled(ScopeButton)`
  && {
    font-size: 13px;
    font-weight: 700;
  }
`;

export const GroupAddReturnButtonWrap = styled.div`
  display: inline-flex;
`;

export const NextPeriodLineBreak = styled('br')``;
